"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpResultWrapper = httpResultWrapper;
const errors_1 = require("@invivodf/errors");
const utils_1 = require("@invivodf/utils");
const is_functionnal_api_error_1 = require("../is-functionnal-api-error");
const is_payload_validation_error_1 = require("../is-payload-validation-error");
async function httpResultWrapper(httpCall, transform) {
    try {
        const response = await httpCall();
        if (response.status === 204 && response.data === '') {
            return utils_1.Result.success();
        }
        const data = transform ? transform(response) : response.data;
        return utils_1.Result.success(data);
    }
    catch (error) {
        if ((0, is_functionnal_api_error_1.isFunctionalApiError)(error)) {
            return utils_1.Result.failure(new errors_1.ApiError(error.message, '422', error));
        }
        if ((0, is_payload_validation_error_1.isPayloadValidationError)(error)) {
            return utils_1.Result.failure(new errors_1.ApiError(error.message, '400', error));
        }
        throw error;
    }
}
